import layoutEn from '../components/layout/locales/en.json'
import layoutZh from '../components/layout/locales/zh.json'
import menuEn from '../router/locales/en.json'
import menuZh from '../router/locales/zh.json'
import coreEn from './core/en.json'
import coreZh from './core/zh.json'
import { mergeLocales } from './merge-locales'

export type LocaleCode = 'zh' | 'en'

const moduleZhFiles = import.meta.glob<Record<string, unknown>>(
  '../modules/*/i18n/zh.json',
  { eager: true, import: 'default' },
)
const moduleEnFiles = import.meta.glob<Record<string, unknown>>(
  '../modules/*/i18n/en.json',
  { eager: true, import: 'default' },
)

function sortedModuleValues(
  files: Record<string, Record<string, unknown>>,
): Record<string, unknown>[] {
  return Object.keys(files)
    .sort((a, b) => a.localeCompare(b))
    .map((key) => files[key]!)
}

const shellByLocale: Record<LocaleCode, Record<string, unknown>[]> = {
  zh: [coreZh, menuZh, layoutZh],
  en: [coreEn, menuEn, layoutEn],
}

const modulesByLocale: Record<LocaleCode, Record<string, unknown>[]> = {
  zh: sortedModuleValues(moduleZhFiles),
  en: sortedModuleValues(moduleEnFiles),
}

/** 按 core → menu → layout → modules（路径字母序）合并 locale 片段 */
export function buildLocaleMessages(locale: LocaleCode): Record<string, unknown> {
  return mergeLocales(...shellByLocale[locale], ...modulesByLocale[locale])
}
